import { EntityType, FilterSearchDto, SearchResult } from '../../store/Search';
import { buildQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';

const getPatchSearch = (entityTypes: string) => {
  switch (entityTypes) {
    case EntityType.RPM_CUSTOMER_MAP:
      return 'customer-maps/search';
    case EntityType.PAYMENT_RECIPIENT:
      return 'payment-recipients/search';
    default:
      return 'search';
  }
};

export const getSearchResults = (searchDto: FilterSearchDto) => {
  const mergedFilters: FilterSearchDto = {
    limit: searchDto.limit || 10,
    entityTypes:
      searchDto.entityTypes ||
      [
        EntityType.CUSTOMER,
        EntityType.ASSET,
        EntityType.ACCOUNT,
        EntityType.TICKET,
        EntityType.PROVISIONAL_ASSET,
        EntityType.PRODUCT,
        EntityType.RPM_PRODUCT
      ].join(','),
    query: searchDto.query,
    ...(!!searchDto.filters && searchDto.filters)
  };
  const patchSearch = getPatchSearch(mergedFilters.entityTypes || '');
  return apiService.callExternalApi<SearchResult[]>({
    url: buildQueryURL(mergedFilters, patchSearch),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const getDetailsSearchResults = (searchDto: FilterSearchDto) => {
  const mergedFilters: FilterSearchDto = {
    limit: searchDto.limit || 10,
    entityTypes:
      searchDto.entityTypes ||
      [EntityType.ASSET, EntityType.CUSTOMER, EntityType.PROVISIONAL_ASSET, EntityType.ACCOUNT, EntityType.TICKET].join(
        ','
      ),
    query: searchDto.query
  };
  return apiService.callExternalApi<Record<string, object[]>>({
    url: buildQueryURL(mergedFilters, 'search/details'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
